<template>
  <div>
    <el-row>
      <el-col :span="4">
        <el-select
            v-model="platform"
            style="width: 100%"
            clearable
            placeholder="选择平台"
            @change="changePlatform"
        >
          <el-option label="淘宝" :value="1"></el-option>
          <el-option label="天猫" :value="2"></el-option>
          <el-option label="京东" :value="3"></el-option>
          <el-option label="拼多多" :value="5"></el-option>
          <el-option label="苏宁" :value="6"></el-option>
          <el-option label="抖音" :value="119"></el-option>
          <el-option label="快手" :value="10083"></el-option>
          <el-option label="闲鱼" :value="10"></el-option>
          <el-option label="京东到家" :value="203"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4" :offset="2">
        <el-input v-model="crawlerVersion" placeholder="输入版本号" ></el-input>
      </el-col>
      <el-button type="primary" @click="queryFirst" >查询</el-button>
      <el-button type="primary" @click="nextPage" v-if="next !== ''">下一页</el-button>
    </el-row>
    <el-row style="padding-top: 10px;" :gutter="10">
      <el-col :span="8" v-for="(o) in urls" :key="o.name" >
        <el-card :body-style="{ 'padding-top': '10px' }">
          <img :src="o.path" class="image">
          <div style="padding: 14px;">
            <span>{{o.name}}</span>
          </div>
        </el-card>
      </el-col>

    </el-row>

  </div>

</template>
<script>
import axios from 'axios'

export default {
  name: "honorCaptureImages",
  data() {
    return {
      platform:'',
      crawlerVersion: "",
      urls: [],
      next: ''
    };
  },
  methods: {
    changePlatform() {
      this.next = ""
      this.generate();
    },
    queryFirst() {
      this.next = '';
      this.generate();
    },
    nextPage() {
      this.generate();
    },
    generate() {
      var _self = this;
      axios
          .get("/api/queryHonorScImages?next="+_self.next + "&platform=" + _self.platform + "&crawlerVersion=" + _self.crawlerVersion )
          .then((content) => {
            console.log(content)
            if(content.status === 200) {
              _self.urls = content.data.urls;
              if(content.data.next !== undefined) {
                _self.next = content.data.next;
              }

              console.log(_self.urls)
            }
          });
    },
  },
  mounted() {
    this.generate();
  },
};
</script>
<style>
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}
</style>
